import React from 'react';
import MainBody from '../templates/MainBody';
import { imintContent } from '../data';

const IMINT: React.FC = () => {
  return <MainBody data={imintContent} />;
};

export default IMINT;